<template>
  <v-container fluid grid-list-lg>

    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getList"
      :editDonationCategory="selectedDonationCategory"></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle :access="checkRightStatus(85)" title="Donation Category" @add="add" />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
            hide-details clearable></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="donationCategories" :search="search" :loading="loading"
          :sort-by="sortBy" :page.sync="page" :items-per-page="itemsPerPage">
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <!-- <td class="text-left">{{ item.createdAt | moment('MM/DD/YYYY') }}</td> -->
              <td class="text-left">
                <span v-html="$options.filters.highlight(item.name, search.toLowerCase())
                  ">{{ item.name }}</span>
              </td>

              <td class="text-left">
                <span v-html="$options.filters.highlight(item.MerchantAccount.name, search.toLowerCase())">{{
                  item.MerchantAccount.name}}</span>
                <v-chip v-if="item.isLock" class="ml-2" color="indigo" text-color="white" small>
                  <v-avatar left >
                    <v-icon small>mdi-lock</v-icon>
                  </v-avatar>
                  Locked
                </v-chip>
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item v-if="checkRightStatus(87)" @click="editDonationCategory(item)">
                      <v-list-item-title>{{
                        $t("buttons.edit")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!item.isLock && checkRightStatus(88)" @click="deleteDonationCategory(item)">
                      <v-list-item-title>{{
                        $t("buttons.delete")
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
            results.</v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import donationCategoryService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "donationCategory-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedDonationCategory: null,
      headers: [
        // {
        //     text: this.$t("labels.date"),
        //     align: "left",
        //     value: "createdAt",
        //     sortable: true,
        //     width: '30%',
        //   },
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: true,
          width: '30%',
        },
        {
          text: "Merchant Account",
          value: "MerchantAccount.name",
          align: "left",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      donationCategories: [],
      search: "",
      loading: true,
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    if (this.$route.query && this.$route.query.search) {
      this.search = this.$route.query.search;
    }
    document.title = "taleem - DonationCategory";
  },
  components: {
    Create,
    Edit,
  },
  filters: {
    highlight(words, query) {
      if (query) {
        var check = new RegExp(query.toLowerCase(), "ig");
        if (words) {
          return words.toString().replace(check, function (matchedText) {
            return '<span class="highlight">' + matchedText + "</span>";
          });
        } else {
          return words;
        }
      } else {
        return words;
      }
    },
  },
  watch: {
    search(val) {
      if (!val) {
        this.search = "";
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      // console.log("this. vd", this.editDialog)
      this.createDialog = false;
      return donationCategoryService.getAll().then((response) => {
        console.log('response donation', response)
        this.loading = false;
        this.donationCategories = response.data;
        return response;
      });
    },
    editDonationCategory(donationCategory) {
      this.selectedDonationCategory = donationCategory;
      this.editDialog = !this.editDialog;
    },
    deleteDonationCategory(donationCategory) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          donationCategoryService.delete(donationCategory.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Donation Category has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
